import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class RequestHelper  {
    _originalTypeClassName = "zSHR.BO.RequestHelper";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
RequestHelper.translate = translateService;
}
this.RequestHelperKey = null;
this._key = this.RequestHelperKey = 0; 
}

static translate: TranslateService;
_key: any;
private _RequestHelperKey:any;
get RequestHelperKey(): any {
    return this._RequestHelperKey;
  }
set RequestHelperKey(value: any) {
    this._RequestHelperKey = value;
    this._key = value;
  }

static GetCurrentUser(): any{return Joove.Common.cast(window._context.currentUser, "Domain.UserAccount");
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.RequestHelperKey == null || $this.RequestHelperKey == 0;
            }


}